<template>
  <div class="wrap">
    <commonPageBanner :url="backUrl" />
    <div class="content_area">
      <div class="search-wrap">
        <div class="title">{{ $t('creditAssessment') }}</div>
        <div class="searchBtn">
          <searchCompany genreType="1" v-model="queryParams.companyName" @search="search"
            :placeTitle="$t('ccompanyPlaceholder')" class="search-wrap" />
        </div>
      </div>
      <filterSearch @handleSearch="handleSearch" :yearShow="yearShow" />
      <div class="main">
        <div class="left" v-loading="loading">
          <div>
            <creditItem v-for="(item, index) in companyList" :companyInfo="item" :key="index" :videoShow="videoShow"
              :showType="2" />
          </div>
          <isLoadingTip v-if="loading" />
          <noDataImg v-if="companyList.length === 0"></noDataImg>
          <div class="my_pagination">
            <el-pagination :current-page="currentPage" @current-change="handleChange" :hide-on-single-page='true'
              background layout="prev, pager, next" :page-size="pageSize" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="right" v-loading="rightLoading">
          <div class="text" v-for="(item, index) in historyList" :key="index" @click="clickData(item)">
            {{ item.title | textFormat }}
          </div>
          <noDataImg v-if="historyList.length === 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonPageBanner from "~sif/components/layouts/pageBanner";
import searchCompany from "@/projects/siffa/components/company/unit/searchCompany";
import creditItem from "@/projects/siffa/components/company/unit/creditItem";
import filterSearch from "~sif/components/common/filterSearch";
import isLoadingTip from "@/baseComponents/isLoadingTip";
import isAllDataTip from "@/baseComponents/isAllDataTip";

export default {
  name: "credit",
  metaInfo() {
    return {
      title: this.$t("creditAssessment"),
    };
  },
  components: {
    commonPageBanner,
    searchCompany,
    creditItem,
    filterSearch,
    isLoadingTip,
    isAllDataTip,
  },
  data() {
    return {
      queryParams: {
        companyName: "",
      },
      backUrl:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/siffa/banner3.png",
      loading: false,
      pageSize: 10,
      total: 0,
      currentPage: 1,
      filters: {
        city: "",
        unitType: "",
        credit: "",
        year: 2026,
      },
      companyList: [],
      yearShow: true,
      videoShow: false,
      historyList: [],
      rightLoading: false,
    };
  },
  mounted() {
    this.getList(1);
    this.getHistoryList();
    // window.addEventListener("scroll", this.scrollEvent, false);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.scrollEvent, false);
  },
  methods: {
    handleData(obj) {
      let arr = [];
      for (let i in obj) {
        arr = arr.concat(obj[i]);
      }
      return arr;
    },
    handleChange(index) {
      this.currentPage = index;
      this.getList();
    },
    async getList(type) {
      // window.removeEventListener("scroll", this.scrollEvent, false);
      //type 1是搜索赋值 2是下拉拼接
      this.loading = true;
      let params = {};
      params.start = this.currentPage - 1;
      params.limit = this.pageSize;
      params.city_id = this.filters.city;
      params.genre_ids = this.filters.unitType;
      params.company_credit = this.filters.credit;
      params.certificate = 20;
      params.company_source = this.PJSource;
      params.user_id = this.USER_ID;
      params.name = this.queryParams.companyName;
      params.year = this.filters.year;
      params.source = 7;
      let res = await this.$store.dispatch(
        "API_company/getCompanyCreditList",
        params
      );
      if (res.success) {
        // window.addEventListener("scroll", this.scrollEvent, false);
        res.data.forEach((item) => {
          item.business_classification_list = this.handleData(
            item.business_classification_info
          );
        });
        res.data.forEach((item, index) => {
          if (item.genre_ids.length > 1) {
            item.genre_ids = item.genre_ids.filter((ee) => ee != "1");
            item.genre_ids = [...new Set(item.genre_ids)]
          }
        });
        this.loading = false;
        this.companyList = res.data;
        this.total = res.total;

        document.body.scrollTop = document.documentElement.scrollTop = 0;

      }
    },
    async getHistoryList() {
      this.rightLoading = true;
      let params = {};
      params.content_type = 5;
      params.source = 7;
      params.language = 2;
      params.is_show = 1;
      let res = await this.$store.dispatch(
        "API_index/getStaticContent",
        params
      );
      if (res.success) {
        this.rightLoading = false;
        this.historyList = res.data;
      }
    },
    search() {
      this.currentPage = 1;
      this.getList(1);
    },
    handleSearch(val) {
      this.filters = val;
      this.currentPage = 1;
      this.getList(1);
    },
    scrollEvent() {
      if (
        document.documentElement.scrollTop +
        document.documentElement.clientHeight >=
        document.body.scrollHeight - 354
      ) {
        if (this.total != this.companyList.length) {
          this.getList(2);
        }
      }
    },
    clickData(item) {
      this.$router.push({
        path: "/creditDetail",
        query: {
          parameter: this._encode({
            info_id: item.id,
          }),
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  .search-wrap {
    display: flex;
    margin-bottom: 16px;
    justify-content: space-between;

    .title {
      height: 40px;
      font-size: 24px;
      font-weight: bold;
      color: #666666;
      line-height: 40px;
    }
  }

  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    .left {
      width: 896px;
      position: relative;
      min-height: 200px;
    }

    .right {
      min-height: 200px;
      width: 280px;
      position: relative;

      .text {
        margin-bottom: 16px;
        word-break: break-all;
        word-wrap: break-word;
        break-word: break-all;
        font-size: 14px;
        font-weight: 400;
        color: #333333;

        &:hover {
          cursor: pointer;
          color: #027fff;
        }
      }
    }
  }
}

.my_pagination {
  text-align: right;
  margin: 10px 0px 30px;
}
</style>
